// extracted by mini-css-extract-plugin
export default {"elements":"src-components-Footer-NewsletterForm__elements","button":"src-components-Footer-NewsletterForm__button"};